import styled from 'styled-components';
import { MdClose } from 'react-icons/md';

export const Background = styled.div`
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.8);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
`;

export const ModalContent = styled.div`
    max-width: 90%;
    width: 380px;
    margin: 0 auto;
    background: #FFF;
    border-radius: 0.25rem;
    box-shadow: 0px 3px 12px -3px rgba(0, 0, 0, 0.5);
    padding: 2rem 1.5rem;
    position: relative;
    text-align: center;
`;

export const CloseModalButton = styled(MdClose)`
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;
    width: 32px;
    height: 32px;
    padding: 0;
    z-index: 10;
`;

export const Title = styled.h3`
    margin-bottom: 1.5rem;
    text-transform: uppercase;
`;

export const StatusText = styled.p`
    margin-bottom: 1.5rem;
    font-size: 16px;
    color: #000000;
`;

export const ToggleContainer = styled.div`
    display: flex;
    justify-content: center;
`;
